import React from 'react';

export default function TankWithRivetsLadderIcon({
  width = 64,
  height = 64,
  startColor = '#383838',
  midColor = '#ECECEC',
  endColor = '#383838'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="0" y1="58.5586" x2="112.5" y2="58.5586">
		<stop offset="0" style={{stopColor: "#383838"}} />
		<stop offset="0.45" style={{stopColor: "#ECECEC"}} />
		<stop offset="0.55" style={{stopColor: "#D9D9D9"}} />
		<stop offset="0.76" style={{stopColor: "#A8A8A8"}} />
		<stop offset="0.77" style={{stopColor: "#A6A6A6"}} />
		<stop offset="1" style={{stopColor: "#383838"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M112.5,107.771V4.617H0v103.379c0,0,5.125,4.504,56.194,4.504c1.437,0,4.307-0.113,5.744-0.113   C110.969,112.387,112.5,107.771,112.5,107.771z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="56.1929" y1="0" x2="56.1929" y2="9.2344">
		<stop offset="0" style={{stopColor: "#C8C8C8"}} />
		<stop offset="0.29" style={{stopColor: "#B1B1B1"}} />
		<stop offset="0.91" style={{stopColor: "#757575"}} />
		<stop offset="1" style={{stopColor: "#6C6C6C"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M56.194,0c30.919,0,56.193,2.055,56.193,4.617c0,2.55-25.158,4.617-56.193,4.617   C25.159,9.234,0,7.167,0,4.617S25.159,0,56.194,0z" />
	<path fill="#7F7F7F" d="M23.423,11.599h2.365v2.365h-2.365V11.599z" />
	<path fill="#7F7F7F" d="M23.423,21.059h2.365v2.365h-2.365V21.059z" />
	<path fill="#7F7F7F" d="M23.423,30.405h2.365v2.365h-2.365V30.405z" />
	<path fill="#7F7F7F" d="M23.423,39.752h2.365v2.365h-2.365V39.752z" />
	<path fill="#7F7F7F" d="M23.423,49.099h2.365v2.365h-2.365V49.099z" />
	<path fill="#7F7F7F" d="M23.423,58.559h2.365v2.365h-2.365V58.559z" />
	<path fill="#7F7F7F" d="M23.423,67.905h2.365v2.365h-2.365V67.905z" />
	<path fill="#7F7F7F" d="M23.423,77.252h2.365v2.365h-2.365V77.252z" />
	<path fill="#7F7F7F" d="M23.423,86.6h2.365v2.364h-2.365V86.6z" />
	<path fill="#7F7F7F" d="M23.423,96.059h2.365v2.365h-2.365V96.059z" />
	<path fill="#7F7F7F" d="M23.423,105.405h2.365v2.365h-2.365V105.405z" />
	<path fill="#999999" d="M70.271,11.599h2.364v2.365h-2.364V11.599z" />
	<path fill="#999999" d="M70.271,21.059h2.364v2.365h-2.364V21.059z" />
	<path fill="#999999" d="M70.271,30.405h2.364v2.365h-2.364V30.405z" />
	<path fill="#999999" d="M70.271,39.752h2.364v2.365h-2.364V39.752z" />
	<path fill="#999999" d="M70.271,49.099h2.364v2.365h-2.364V49.099z" />
	<path fill="#999999" d="M70.271,58.559h2.364v2.365h-2.364V58.559z" />
	<path fill="#999999" d="M70.271,67.905h2.364v2.365h-2.364V67.905z" />
	<path fill="#999999" d="M70.271,77.252h2.364v2.365h-2.364V77.252z" />
	<path fill="#999999" d="M70.271,86.6h2.364v2.364h-2.364V86.6z" />
	<path fill="#999999" d="M70.271,96.059h2.364v2.365h-2.364V96.059z" />
	<path fill="#999999" d="M70.271,105.405h2.364v2.365h-2.364V105.405z" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M28.041,8.671v103.153" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M75,8.671v103.153" />
</g>
<g id="Group_Ladder">
	<path fill="#FFCC00" d="M94.707,2.815c-6.874-2.015-8.783,3.041-8.783,3.041l1.914,1.126c0,0,2.578-3.439,5.969-2.027   c3.006,1.252,2.814,4.392,2.814,4.392H86.6c0,0-0.299-4.461-3.604-6.193C76.979,0,73.648,5.856,73.648,5.856l1.914,1.126   c0,0,2.224-3.708,5.856-2.027c3.237,1.498,2.928,4.392,2.928,4.392V112.5h2.365l-0.008-7.095h9.917v6.419h2.365V9.347   C98.986,9.347,98.847,4.029,94.707,2.815z M86.633,39.752h9.988v7.094h-9.98L86.633,39.752z M96.621,28.041H86.62l-0.008-6.982   h10.009V28.041z M96.621,30.405V37.5H86.63l-0.007-7.095H96.621z M86.643,49.099h9.979v7.095H86.65L86.643,49.099z M96.621,58.559   v6.982h-9.96l-0.008-6.982H96.621z M96.621,67.905V75h-9.95l-0.008-7.095H96.621z M86.674,77.252h9.947v7.095h-9.909V86.6h9.909   v7.094h-9.93L86.674,77.252z M96.621,11.599v7.095H86.609l-0.008-7.095H96.621z M86.701,103.041l-0.007-6.982h9.927v6.982H86.701z" />
	<path fill="none" d="M86.712,9.347h9.347v2.252h-9.347V9.347" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
